var map = {
	"./bolo/1macaxeira.webp": 548,
	"./bolo/1milho.webp": 9629,
	"./bolo/1pacoca.webp": 1238,
	"./bolo/bolobanana.webp": 8977,
	"./bolo/bolobananasemacucar.webp": 9599,
	"./bolo/bololimao.webp": 2122,
	"./bolo/bolomaca.webp": 6301,
	"./bolo/cenoura.webp": 2900,
	"./bolo/chocolate.webp": 3264,
	"./bolo/churros.webp": 2649,
	"./bolo/goiabada.webp": 4612,
	"./bolo/laranja.webp": 3084,
	"./bolo/natalino.webp": 4090,
	"./bolo/ninho.webp": 606,
	"./bolo/noiva.webp": 1776,
	"./bolo_nb/1macaxeira.webp": 3586,
	"./bolo_nb/1milho.webp": 2728,
	"./bolo_nb/1pacoca.webp": 728,
	"./bolo_nb/bolobanana.webp": 6510,
	"./bolo_nb/bolobananasemacucar.webp": 8213,
	"./bolo_nb/bololimao.webp": 8506,
	"./bolo_nb/bolomaca.webp": 1735,
	"./bolo_nb/cenoura.webp": 5885,
	"./bolo_nb/chocolate.webp": 5390,
	"./bolo_nb/churros.webp": 739,
	"./bolo_nb/goiabada.webp": 5961,
	"./bolo_nb/laranja.webp": 2266,
	"./bolo_nb/ninho.webp": 5916,
	"./bolo_nb/noiva.webp": 7332,
	"./bolo_thumb/1macaxeira.webp": 5651,
	"./bolo_thumb/1milho.webp": 7449,
	"./bolo_thumb/1pacoca.webp": 8989,
	"./bolo_thumb/bolobanana.webp": 9317,
	"./bolo_thumb/bolobananasemacucar.webp": 7740,
	"./bolo_thumb/bololimao.webp": 9377,
	"./bolo_thumb/bolomaca.webp": 6668,
	"./bolo_thumb/cenoura.webp": 5491,
	"./bolo_thumb/chocolate.webp": 1416,
	"./bolo_thumb/churros.webp": 1073,
	"./bolo_thumb/goiabada.webp": 3044,
	"./bolo_thumb/laranja.webp": 3848,
	"./bolo_thumb/ninho.webp": 1743,
	"./bolo_thumb/noiva.webp": 1504,
	"./fatias/alema.webp": 4068,
	"./fatias/alema_amendoim.webp": 9743,
	"./fatias/alema_branca.webp": 3612,
	"./fatias/alema_nozes.webp": 5190,
	"./fatias/alema_ovomaltine.webp": 5809,
	"./fatias/alema_sem_acucar.webp": 3277,
	"./fatias/ameixa.webp": 8847,
	"./fatias/amendoim_sem_acucar.webp": 537,
	"./fatias/banana.webp": 301,
	"./fatias/banoffee.webp": 2280,
	"./fatias/bombonzao.webp": 8750,
	"./fatias/brigadeiro.webp": 5666,
	"./fatias/brownie.webp": 1449,
	"./fatias/brownie_morango.webp": 7210,
	"./fatias/cafe.webp": 2930,
	"./fatias/caramelo.webp": 7375,
	"./fatias/cheesecake.webp": 3955,
	"./fatias/cheesecake_goiaba.webp": 973,
	"./fatias/cheesecake_nutella.webp": 8496,
	"./fatias/cheesecake_sem_acucar.webp": 3868,
	"./fatias/chocolatra.webp": 3389,
	"./fatias/damasco.webp": 6982,
	"./fatias/docedelicia.webp": 9110,
	"./fatias/domino.webp": 5892,
	"./fatias/donaana.webp": 3609,
	"./fatias/feitico.webp": 8246,
	"./fatias/gabriela.webp": 3543,
	"./fatias/limao.webp": 4240,
	"./fatias/maca.webp": 3635,
	"./fatias/maracuja.webp": 4218,
	"./fatias/menta.webp": 1167,
	"./fatias/mesclada.webp": 5325,
	"./fatias/morango.webp": 6151,
	"./fatias/mousse.webp": 3998,
	"./fatias/mousse_brigadeiro.webp": 5341,
	"./fatias/mousse_sem_acucar.webp": 8999,
	"./fatias/nozes.webp": 2050,
	"./fatias/paodemel.webp": 927,
	"./fatias/pontanegra.webp": 694,
	"./fatias/profiterolis.webp": 5846,
	"./fatias/redvelvet.webp": 2608,
	"./fatias/romeu.webp": 8045,
	"./fatias/seducao.webp": 8337,
	"./fatias/spumone.webp": 5169,
	"./fatias/tentacao.webp": 3016,
	"./fatias/tropical.webp": 2090,
	"./junino/macaxeira.webp": 5344,
	"./junino/milho.webp": 4888,
	"./junino/pacoca.webp": 7063,
	"./junino_nb/macaxeira.webp": 779,
	"./junino_nb/milho.webp": 1165,
	"./junino_nb/pacoca.webp": 2546,
	"./junino_thumb/macaxeira.webp": 8925,
	"./junino_thumb/milho.webp": 4759,
	"./junino_thumb/pacoca.webp": 9489,
	"./natal/natal_1barra.webp": 1187,
	"./natal/natal_1disco.webp": 5894,
	"./natal/natal_alema.webp": 9856,
	"./natal/natal_boloreis.webp": 4318,
	"./natal/natal_brigadeiro.webp": 6829,
	"./natal/natal_brownie_morango.webp": 1166,
	"./natal/natal_cafe.webp": 8708,
	"./natal/natal_caramelo.webp": 133,
	"./natal/natal_cenoura.webp": 3239,
	"./natal/natal_cheesecake.webp": 3610,
	"./natal/natal_cheesecake_goiaba.webp": 6726,
	"./natal/natal_cheesecake_nutella.webp": 527,
	"./natal/natal_chocolate.webp": 3160,
	"./natal/natal_damasco.webp": 3972,
	"./natal/natal_domino.webp": 48,
	"./natal/natal_donaana.webp": 97,
	"./natal/natal_limao.webp": 5317,
	"./natal/natal_menta.webp": 7547,
	"./natal/natal_morango.webp": 6098,
	"./natal/natal_mousse_brigadeiro.webp": 7946,
	"./natal/natal_natalino.webp": 7699,
	"./natal/natal_nozes.webp": 9829,
	"./natal/natal_redvelvet.webp": 4982,
	"./natal/natal_seducao.webp": 2872,
	"./natal/natal_tentacao.webp": 7468,
	"./natal/natal_tropical.webp": 5566,
	"./natal2/1barra.webp": 5826,
	"./natal2/1disco.webp": 863,
	"./natal2/boloreis.webp": 9330,
	"./natal2/natalino.webp": 1833,
	"./natal_nb/natal_1barra.webp": 6708,
	"./natal_nb/natal_1disco.webp": 26,
	"./natal_nb/natal_alema.webp": 5360,
	"./natal_nb/natal_boloreis.webp": 6470,
	"./natal_nb/natal_brigadeiro.webp": 3901,
	"./natal_nb/natal_brownie_morango.webp": 5243,
	"./natal_nb/natal_cafe.webp": 1146,
	"./natal_nb/natal_caramelo.webp": 9574,
	"./natal_nb/natal_cenoura.webp": 3677,
	"./natal_nb/natal_cheesecake.webp": 8533,
	"./natal_nb/natal_cheesecake_goiaba.webp": 9919,
	"./natal_nb/natal_cheesecake_nutella.webp": 5149,
	"./natal_nb/natal_chocolate.webp": 3807,
	"./natal_nb/natal_damasco.webp": 5805,
	"./natal_nb/natal_domino.webp": 4741,
	"./natal_nb/natal_donaana.webp": 2598,
	"./natal_nb/natal_limao.webp": 4473,
	"./natal_nb/natal_menta.webp": 855,
	"./natal_nb/natal_morango.webp": 3750,
	"./natal_nb/natal_mousse_brigadeiro.webp": 9865,
	"./natal_nb/natal_natalino.webp": 9409,
	"./natal_nb/natal_nozes.webp": 5402,
	"./natal_nb/natal_redvelvet.webp": 354,
	"./natal_nb/natal_seducao.webp": 6419,
	"./natal_nb/natal_tentacao.webp": 839,
	"./natal_nb/natal_tropical.webp": 508,
	"./pascoa/pascoa_alema.webp": 4629,
	"./pascoa/pascoa_barra.webp": 3601,
	"./pascoa/pascoa_biscoito.webp": 7996,
	"./pascoa/pascoa_bombom.webp": 486,
	"./pascoa/pascoa_brigadeiro.webp": 2015,
	"./pascoa/pascoa_brow.webp": 8480,
	"./pascoa/pascoa_brownozes.webp": 2451,
	"./pascoa/pascoa_caixabrow.webp": 7871,
	"./pascoa/pascoa_crocante.webp": 8220,
	"./pascoa/pascoa_domino.webp": 4638,
	"./pascoa/pascoa_lata.webp": 3499,
	"./pascoa_nb/pascoa_alema.webp": 4358,
	"./pascoa_nb/pascoa_barra.webp": 2749,
	"./pascoa_nb/pascoa_biscoito.webp": 2926,
	"./pascoa_nb/pascoa_bombom.webp": 4832,
	"./pascoa_nb/pascoa_brigadeiro.webp": 5016,
	"./pascoa_nb/pascoa_brow.webp": 8928,
	"./pascoa_nb/pascoa_brownozes.webp": 6090,
	"./pascoa_nb/pascoa_caixabrow.webp": 9677,
	"./pascoa_nb/pascoa_crocante.webp": 4906,
	"./pascoa_nb/pascoa_domino.webp": 8273,
	"./pascoa_nb/pascoa_lata.webp": 4044,
	"./torta/_modelo.webp": 3358,
	"./torta/alema.webp": 8405,
	"./torta/alema_amendoim.webp": 7348,
	"./torta/alema_amendoim_p.webp": 2852,
	"./torta/alema_branca.webp": 3680,
	"./torta/alema_branca_p.webp": 8682,
	"./torta/alema_nozes.webp": 3578,
	"./torta/alema_nozes_p.webp": 7942,
	"./torta/alema_ovomaltine.webp": 2946,
	"./torta/alema_ovomaltine_p.webp": 1464,
	"./torta/alema_p.webp": 7089,
	"./torta/alema_sem_acucar.webp": 7150,
	"./torta/alema_sem_acucar_p.webp": 3006,
	"./torta/ameixa.webp": 1208,
	"./torta/ameixa_p.webp": 6287,
	"./torta/amendoim_sem_acucar.webp": 2462,
	"./torta/amendoim_sem_acucar_p.webp": 6075,
	"./torta/banana.webp": 8580,
	"./torta/banana_p.webp": 3697,
	"./torta/banoffee.webp": 2006,
	"./torta/banoffee_p.webp": 769,
	"./torta/bombonzao.webp": 3994,
	"./torta/bombonzao_p.webp": 4651,
	"./torta/brigadeiro.webp": 1077,
	"./torta/brigadeiro_p.webp": 3754,
	"./torta/brownie.webp": 670,
	"./torta/brownie_morango.webp": 110,
	"./torta/brownie_morango_p.webp": 8712,
	"./torta/brownie_p.webp": 5476,
	"./torta/cafe.webp": 3339,
	"./torta/cafe_p.webp": 2987,
	"./torta/caramelo.webp": 4370,
	"./torta/caramelo_p.webp": 8768,
	"./torta/cheesecake.webp": 7873,
	"./torta/cheesecake_goiaba.webp": 3827,
	"./torta/cheesecake_goiaba_p.webp": 1082,
	"./torta/cheesecake_nutella.webp": 9557,
	"./torta/cheesecake_nutella_p.webp": 1170,
	"./torta/cheesecake_p.webp": 9623,
	"./torta/cheesecake_sem_acucar.webp": 487,
	"./torta/cheesecake_sem_acucar_p.webp": 808,
	"./torta/chocolatra.webp": 1530,
	"./torta/chocolatra_p.webp": 1700,
	"./torta/damasco.webp": 3557,
	"./torta/damasco_p.webp": 8265,
	"./torta/docedelicia.webp": 4883,
	"./torta/docedelicia_p.webp": 8916,
	"./torta/domino.webp": 5405,
	"./torta/domino_p.webp": 4220,
	"./torta/donaana.webp": 6085,
	"./torta/donaana_p.webp": 3099,
	"./torta/feitico.webp": 2537,
	"./torta/feitico_p.webp": 8929,
	"./torta/gabriela.webp": 418,
	"./torta/gabriela_p.webp": 9482,
	"./torta/limao.webp": 4435,
	"./torta/limao_p.webp": 2665,
	"./torta/maca.webp": 9407,
	"./torta/maca_p.webp": 6459,
	"./torta/maracuja.webp": 6053,
	"./torta/maracuja_p.webp": 7877,
	"./torta/menta.webp": 4450,
	"./torta/menta_p.webp": 2518,
	"./torta/mesclada.webp": 6978,
	"./torta/mesclada_p.webp": 8516,
	"./torta/morango.webp": 2097,
	"./torta/morango_p.webp": 8696,
	"./torta/mousse.webp": 1626,
	"./torta/mousse_brigadeiro.webp": 5165,
	"./torta/mousse_brigadeiro_p.webp": 7559,
	"./torta/mousse_p.webp": 130,
	"./torta/mousse_sem_acucar.webp": 3040,
	"./torta/mousse_sem_acucar_p.webp": 29,
	"./torta/nozes.webp": 7534,
	"./torta/nozes_p.webp": 8042,
	"./torta/paodemel.webp": 5268,
	"./torta/paodemel_p.webp": 7324,
	"./torta/pontanegra.webp": 1171,
	"./torta/pontanegra_p.webp": 6836,
	"./torta/profiterolis.webp": 5187,
	"./torta/profiterolis_p.webp": 9366,
	"./torta/redvelvet.webp": 9351,
	"./torta/redvelvet_p.webp": 2437,
	"./torta/romeu.webp": 3742,
	"./torta/romeu_p.webp": 3974,
	"./torta/seducao.webp": 3314,
	"./torta/seducao_p.webp": 2719,
	"./torta/spumone.webp": 5886,
	"./torta/spumone_p.webp": 2620,
	"./torta/tentacao.webp": 3918,
	"./torta/tentacao_p.webp": 2958,
	"./torta/tropical.webp": 4849,
	"./torta/tropical_p.webp": 6705,
	"./torta_nb/alema.webp": 8896,
	"./torta_nb/alema_amendoim.webp": 1241,
	"./torta_nb/alema_branca.webp": 3368,
	"./torta_nb/alema_nozes.webp": 1099,
	"./torta_nb/alema_ovomaltine.webp": 5276,
	"./torta_nb/alema_sem_acucar.webp": 8444,
	"./torta_nb/ameixa.webp": 3271,
	"./torta_nb/amendoim_sem_acucar.webp": 4371,
	"./torta_nb/banana.webp": 1811,
	"./torta_nb/banoffee.webp": 3198,
	"./torta_nb/bombonzao.webp": 7941,
	"./torta_nb/brigadeiro.webp": 9483,
	"./torta_nb/brownie.webp": 3118,
	"./torta_nb/brownie_morango.webp": 8024,
	"./torta_nb/cafe.webp": 1228,
	"./torta_nb/caramelo.webp": 9899,
	"./torta_nb/cheesecake.webp": 755,
	"./torta_nb/cheesecake_goiaba.webp": 2783,
	"./torta_nb/cheesecake_nutella.webp": 5403,
	"./torta_nb/cheesecake_sem_acucar.webp": 8767,
	"./torta_nb/chocolatra.webp": 6189,
	"./torta_nb/damasco.webp": 9885,
	"./torta_nb/docedelicia.webp": 9400,
	"./torta_nb/domino.webp": 1949,
	"./torta_nb/donaana.webp": 3913,
	"./torta_nb/feitico.webp": 6615,
	"./torta_nb/gabriela.webp": 5062,
	"./torta_nb/limao.webp": 7285,
	"./torta_nb/maca.webp": 902,
	"./torta_nb/maracuja.webp": 4624,
	"./torta_nb/menta.webp": 2504,
	"./torta_nb/mesclada.webp": 1994,
	"./torta_nb/morango.webp": 6578,
	"./torta_nb/mousse.webp": 3690,
	"./torta_nb/mousse_brigadeiro.webp": 4034,
	"./torta_nb/mousse_sem_acucar.webp": 3263,
	"./torta_nb/nozes.webp": 1853,
	"./torta_nb/paodemel.webp": 9877,
	"./torta_nb/pontanegra.webp": 6215,
	"./torta_nb/profiterolis.webp": 8856,
	"./torta_nb/redvelvet.webp": 7497,
	"./torta_nb/romeu.webp": 4101,
	"./torta_nb/seducao.webp": 2232,
	"./torta_nb/spumone.webp": 3562,
	"./torta_nb/tentacao.webp": 6566,
	"./torta_nb/tropical.webp": 9982,
	"./torta_thumb/alema.webp": 7951,
	"./torta_thumb/alema_amendoim.webp": 1857,
	"./torta_thumb/alema_branca.webp": 9780,
	"./torta_thumb/alema_nozes.webp": 2065,
	"./torta_thumb/alema_ovomaltine.webp": 6753,
	"./torta_thumb/alema_sem_acucar.webp": 6061,
	"./torta_thumb/ameixa.webp": 6790,
	"./torta_thumb/amendoim_sem_acucar.webp": 9576,
	"./torta_thumb/banana.webp": 3267,
	"./torta_thumb/banoffee.webp": 1741,
	"./torta_thumb/bombonzao.webp": 8183,
	"./torta_thumb/brigadeiro.webp": 58,
	"./torta_thumb/brownie.webp": 4105,
	"./torta_thumb/brownie_morango.webp": 2275,
	"./torta_thumb/cafe.webp": 7354,
	"./torta_thumb/caramelo.webp": 321,
	"./torta_thumb/cheesecake.webp": 3699,
	"./torta_thumb/cheesecake_goiaba.webp": 430,
	"./torta_thumb/cheesecake_nutella.webp": 4749,
	"./torta_thumb/cheesecake_sem_acucar.webp": 5555,
	"./torta_thumb/chocolatra.webp": 2001,
	"./torta_thumb/damasco.webp": 464,
	"./torta_thumb/docedelicia.webp": 8742,
	"./torta_thumb/domino.webp": 4382,
	"./torta_thumb/donaana.webp": 9951,
	"./torta_thumb/feitico.webp": 6476,
	"./torta_thumb/gabriela.webp": 5353,
	"./torta_thumb/limao.webp": 6532,
	"./torta_thumb/maca.webp": 4174,
	"./torta_thumb/maracuja.webp": 3574,
	"./torta_thumb/menta.webp": 7200,
	"./torta_thumb/mesclada.webp": 9307,
	"./torta_thumb/morango.webp": 6605,
	"./torta_thumb/mousse.webp": 7064,
	"./torta_thumb/mousse_brigadeiro.webp": 998,
	"./torta_thumb/mousse_sem_acucar.webp": 5625,
	"./torta_thumb/nozes.webp": 5551,
	"./torta_thumb/paodemel.webp": 4216,
	"./torta_thumb/pontanegra.webp": 1775,
	"./torta_thumb/profiterolis.webp": 1927,
	"./torta_thumb/redvelvet.webp": 4627,
	"./torta_thumb/romeu.webp": 6004,
	"./torta_thumb/seducao.webp": 7588,
	"./torta_thumb/spumone.webp": 4991,
	"./torta_thumb/tentacao.webp": 2549,
	"./torta_thumb/tropical.webp": 355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4074;